/* kh-drag-rail.js — shared click-and-drag horizontal scrolling for the theme's
   scroll-snap rails. Opt a rail in by adding `data-kh-drag-rail` to its scroll
   container; this script finds them all and wires drag-to-scroll.

   - Mouse / pen only — native touch already swipes, so touch pointers are left
     alone.
   - Only engages when the rail actually overflows (so a non-scrolling desktop
     grid that shares the class, e.g. kh-brand-shop-grid at ≥768px, is untouched).
   - Small drag threshold: an ordinary click still navigates to the product; the
     post-drag click is suppressed ONLY when a real drag happened.
   - scroll-snap is turned off during the drag and restored on release, so the
     rail settles to the nearest card (matching the native swipe feel).
   - Idempotent + self-contained: safe to load once globally or from multiple
     sections; each rail is bound only once.
   - Rails added after load (e.g. the cart drawer, which is re-rendered on every
     cart change) are picked up by a MutationObserver; cards rendered into a
     rail later get draggable="false" at press time. */
(function () {
  var THRESHOLD = 5; // px of movement before a press becomes a drag (a smaller move is a click)

  function bind(rail) {
    if (rail.__khDragRail) return;
    rail.__khDragRail = true;

    // Kill native HTML5 drag on this rail's links/images — it hijacks the press
    // and shows the browser's link/image ghost + no-drop cursor. Firefox honours
    // the attribute; WebKit also needs -webkit-user-drag (injected once below).
    function undrag() {
      var kids = rail.querySelectorAll('a, img');
      for (var k = 0; k < kids.length; k++) { kids[k].setAttribute('draggable', 'false'); }
    }
    undrag();

    var down = false, dragging = false, startX = 0, startLeft = 0, pid = null;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;                 // native touch handles it
      if (e.button !== 0) return;                             // primary button only
      undrag();                                               // cover cards rendered after binding
      if (rail.scrollWidth <= rail.clientWidth + 1) return;   // nothing to scroll
      down = true; dragging = false;
      startX = e.clientX; startLeft = rail.scrollLeft; pid = e.pointerId;
    });

    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD) return;                 // stay a click until past the threshold
        dragging = true;
        rail.style.scrollSnapType = 'none';                   // free-scroll while dragging
        rail.style.userSelect = 'none';
        rail.style.cursor = 'grabbing';
        try { rail.setPointerCapture(pid); } catch (_) {}
      }
      rail.scrollLeft = startLeft - dx;
      e.preventDefault();
    });

    function release() {
      if (!down) return;
      down = false;
      if (dragging) {
        rail.style.scrollSnapType = '';                       // restore CSS snap → settles to nearest card
        rail.style.userSelect = '';
        rail.style.cursor = '';
      }
      try { if (pid != null) rail.releasePointerCapture(pid); } catch (_) {}
    }
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);

    // Never let the browser start a native drag inside a rail — it hijacks the
    // press and shows the link/image ghost. UNCONDITIONAL (not gated on our
    // threshold): native dragstart fires before `dragging` flips, so gating it
    // was the bug that let the ghost through on the first press.
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Swallow the click that fires after a real drag so cards/links don't
    // navigate; capture phase so it beats the link's own handler. Only fires
    // when a drag occurred (ordinary clicks fall through and navigate).
    rail.addEventListener('click', function (e) {
      if (dragging) { e.preventDefault(); e.stopPropagation(); dragging = false; }
    }, true);
  }

  // One-time WebKit safety net (Firefox relies on the draggable="false" above).
  function injectDragCss() {
    if (document.getElementById('kh-drag-rail-css')) return;
    var s = document.createElement('style');
    s.id = 'kh-drag-rail-css';
    s.textContent = '[data-kh-drag-rail] a,[data-kh-drag-rail] img{-webkit-user-drag:none;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function bindWithin(root) {
    if (root.matches && root.matches('[data-kh-drag-rail]')) bind(root);
    var rails = root.querySelectorAll ? root.querySelectorAll('[data-kh-drag-rail]') : [];
    for (var i = 0; i < rails.length; i++) bind(rails[i]);
  }

  function init() {
    injectDragCss();
    bindWithin(document);
    // Rails inserted later (drawer re-renders, JS-rendered sections).
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) bindWithin(added[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
